import Article from "@mui/icons-material/Article";
import AssignmentTurnedIn from "@mui/icons-material/AssignmentTurnedIn";
import Campaign from "@mui/icons-material/Campaign";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import Description from "@mui/icons-material/Description";
import WorkHistory from "@mui/icons-material/WorkHistory";
import { Box, Tooltip } from "@mui/material";
import { orange } from "@mui/material/colors";

import {
  getNotificationCategoryLabel,
  getNotificationProgramAreaLabel,
} from "./notificationPresentation";

function getTypeIconLabel({
  category,
  programArea,
}: {
  category: string;
  programArea: string | null;
}) {
  const parts = [getNotificationCategoryLabel(category)];

  if (programArea) {
    parts.push(getNotificationProgramAreaLabel(programArea));
  }

  return parts.join(" - ");
}

export function NotificationTypeIcon({
  category,
  programArea,
}: {
  category: string;
  programArea: string | null;
}) {
  const label = getTypeIconLabel({ category, programArea });
  let icon = <Article fontSize="small" />;

  if (category === "TASK") {
    icon = <AssignmentTurnedIn fontSize="small" />;
  } else if (category === "JOB") {
    icon = <WorkHistory fontSize="small" />;
  } else if (category === "MARKETING" || category === "STAFF") {
    icon = <Campaign fontSize="small" />;
  } else if (category === "SYSTEM" || category === "ACTIVITY") {
    icon = <Description fontSize="small" />;
  } else if (programArea === "RCRA") {
    icon = <DeleteOutline fontSize="small" />;
  }

  return (
    <Tooltip title={label}>
      <Box
        component="span"
        aria-label={label}
        sx={{
          color: orange[400],
          display: "flex",
          flexShrink: 0,
          pt: "6px",
          alignSelf: "flex-start",
        }}
      >
        {icon}
      </Box>
    </Tooltip>
  );
}
